import { Component, inject } from '@angular/core';
import { Upload } from '../../../core/models/upload.model';
import { Router } from '@angular/router';
import { isEmpty } from 'lodash-es';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { HttpErrorResponse } from '@angular/common/http';
import { PharmacyStoreIdentifierMappingImportsService } from 'app/core/services/pharmacy-store-identifier-mapping-imports.service';

@Component({
  selector: 'app-capture-admin-import-pharmacy-store-identifier-mappings',
  templateUrl: './capture-admin-import-pharmacy-store-identifier-mappings.component.html',
  styleUrls: ['./capture-admin-import-pharmacy-store-identifier-mappings.component.scss'],
  imports: [ImportNavComponent, FileUploadComponent, FaIconComponent]
})
export class CaptureAdminImportPharmacyStoreIdentifierMappingsComponent {
  private pharmacyStoreIdentifierMappingImportsService = inject(PharmacyStoreIdentifierMappingImportsService);
  private router = inject(Router);

  uploading = false;
  formModel = {};
  errors: string[] = [];

  onUploadStart() {
    this.uploading = true;
    this.errors = [];
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.pharmacyStoreIdentifierMappingImportsService.create(upload.signedId).subscribe(
      () => {
        this.router.navigate(['/capture-admin/tools/import-pharmacy-store-identifier-mappings/history']);
        this.uploading = false;
      },
      (error: HttpErrorResponse) => {
        this.uploading = false;
        this.errors = error.error.errors;
      }
    );
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  public get hasError() {
    return !isEmpty(this.errors);
  }
}
